// ============================================================================
// BESPOKIAN Pharmacist Cockpit - PDMP Risk Gauge
// Visual gauge for PDMP risk score display
// ============================================================================

interface RiskGaugeProps {
  score: number; // 0-100
}

export function RiskGauge({ score }: RiskGaugeProps) {
  // Calculate rotation angle (-90 to 90 degrees for half-circle)
  const angle = (score / 100) * 180 - 90;

  // Determine color based on score
  const getColor = (score: number) => {
    if (score <= 30) return '#16a34a'; // green
    if (score <= 60) return '#d97706'; // amber
    return '#dc2626'; // red
  };

  const color = getColor(score);

  return (
    <div className="relative w-48 h-24 mx-auto">
      {/* Background arc */}
      <svg viewBox="0 0 200 100" className="w-full h-full">
        {/* Gray background arc */}
        <path
          d="M 10 100 A 90 90 0 0 1 190 100"
          fill="none"
          stroke="#e5e7eb"
          strokeWidth="16"
          strokeLinecap="round"
        />

        {/* Colored progress arc */}
        <path
          d="M 10 100 A 90 90 0 0 1 190 100"
          fill="none"
          stroke={color}
          strokeWidth="16"
          strokeLinecap="round"
          strokeDasharray={`${(score / 100) * 283} 283`}
        />

        {/* Needle */}
        <g transform={`rotate(${angle} 100 100)`}>
          <line
            x1="100"
            y1="100"
            x2="100"
            y2="25"
            stroke="#1f2937"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <circle cx="100" cy="100" r="8" fill="#1f2937" />
        </g>
      </svg>

      {/* Score label */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 text-2xl font-bold">
        {score}
      </div>

      {/* Scale labels */}
      <div className="absolute bottom-0 left-2 text-xs text-slate-500">0</div>
      <div className="absolute bottom-0 right-2 text-xs text-slate-500">100</div>
    </div>
  );
}
